import { gql } from "@apollo/client";

const FACEBOOKBUSINESSLOGIN = gql`
  mutation facebookBusinessLogin(
    $accesstoken: String!
    $utm_source: String
    $utm_medium: String
    $utm_campaign: String
  ) {
    facebookBusinessLogin(
      accesstoken: $accesstoken
      utm_source: $utm_source
      utm_medium: $utm_medium
      utm_campaign: $utm_campaign
    ) {
      success
      result
      error
    }
  }
`;
export default FACEBOOKBUSINESSLOGIN;
